function directive() {
  return {
    restrict: 'A',
    compile($tElement) {
      const template = '<div class="disabled-component-mask" ng-class="class" ng-if="showing === \'true\'"></div>';

      $tElement.prepend(template);

      return function link($scope, $element, $attrs) {
        $attrs.$observe('disabledComponentMask', () => {
          $scope.showing = $attrs.disabledComponentMask;
          $scope.class = $attrs.maskClass;
        });
      };
    }
  };
}

export default function (ngModule) {
  ngModule.directive('disabledComponentMask', ['$compile', '$rootScope', directive]);
}
